import * as React from 'react';
import * as lodash from 'lodash';

import { IAvailableLanguages } from '@sitegen/common/localization/language-regions';
import { LANGUAGE_NAMES_MAP } from '@sitegen/common/localization';

import AnalyticsService from 'modules/analytics-provider/analytics-provider.service';

import {
    FOOTER_LANGUAGE_SELECT_ID,
    OPEN_LANGUAGE_ANALYTICS_ATTRIBUTES,
    SELECT_LANGUAGE_ANALYTICS_ATTRIBUTES
} from './footer-language-select.constants';
import './footer-language-select.styles.less';

/**
 * Provides list of all languages by default, can be filtered using optional props
 */
export default class FooterLanguageSelect extends React.Component<IFooterLanguageSelectProps> {
    public languageTagOptions: JSX.Element[] = [];

    constructor(props: IFooterLanguageSelectProps) {
        super(props);
        this.languageTagOptions = this.getLanguageTagOptions();
    }

    public componentDidMount() {
        document.addEventListener('mousedown', this.handleClickOutside);
    }

    public componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside);
    }

    public handleClickOutside(event: MouseEvent) {
        const node = document.getElementById(FOOTER_LANGUAGE_SELECT_ID);
        if (!node || !node.contains(event.target as HTMLDivElement)) {
            return;
        }

        return AnalyticsService.sendFlowEvent(OPEN_LANGUAGE_ANALYTICS_ATTRIBUTES);
    }

    private getLanguageTagOptions = (): JSX.Element[] => {
        let languageTags: string[] = Object.keys(LANGUAGE_NAMES_MAP);
        if (this.props.availableLanguageTags) {
            /* Merge all available languages in regions in single list */
            languageTags = lodash.flatten(Object.values(this.props.availableLanguageTags));
        }

        const getOption = (key: string, index: number): JSX.Element => (
            <option key={index} value={key}>
                {LANGUAGE_NAMES_MAP[key]}
            </option>
        );

        return languageTags.sort().map(getOption);
    };

    public onChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
        AnalyticsService.sendFlowEvent({
            ...SELECT_LANGUAGE_ANALYTICS_ATTRIBUTES,
            action: `change language - ${event.target.value}`
        });

        return this.props.onChange(event);
    };


    public render(): JSX.Element {
        return (
            <div id={FOOTER_LANGUAGE_SELECT_ID} className="sitegen-language-select">
                <select
                    value={this.props.activeLanguageTag}
                    onChange={this.onChange}
                >
                    {this.getLanguageTagOptions()}
                </select>
            </div>
        );
    }
}

export interface IFooterLanguageSelectProps {
    readonly activeLanguageTag: string;
    readonly availableLanguageTags?: IAvailableLanguages;
    onChange(e: React.ChangeEvent<HTMLSelectElement>): void;
}
